import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Enquiry } from '../case-enquiry.component';

@Injectable({
    providedIn: 'root'
})
export class CaseEnquiryStateService {
    private selectedEnquirySubject = new BehaviorSubject<Enquiry | null>(null);
    selectedEnquiry$ = this.selectedEnquirySubject.asObservable();

    constructor() { }

    selectEnquiry(enquiry: Enquiry) {
        this.selectedEnquirySubject.next(enquiry);
    }

    clearSelection() {
        this.selectedEnquirySubject.next(null);
    }
}
